import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { FabJob, ListItem, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './fab-job.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class FabJobComponent extends RepositoryModal<FabJob> {
    vpJobOptions: ListItem<string>[] = []

    protected onInitialized(): void {
        const parent = this.editOptions.initializeParams as { vpJobOptions: ListItem<string>[] }
        this.vpJobOptions = parent?.vpJobOptions ?? []

        if (this.isAdding || this.isDuplicating) {
            if (!this.target.id) this.target.id = crypto.randomUUID()
            if (this.target.active === undefined) this.target.active = true
            if (this.target.isInternal === undefined) this.target.isInternal = false
        }
    }

    get vistaJobRequired() {
        return !this.target.isInternal
    }
}
